/* La fattura di un acconto o di un saldo, da fare a mano su Fatture Smart.
 *
 * Adattatore sottile: carica testo e cifre di QUEL gruppo di versamenti dal
 * server e li passa alla pagina a passi (`PassiFattura`), la stessa della
 * fattura normale. Prima di questa pagina, aprendo un acconto si finiva
 * sull'avviso intero col suo importo e il suo testo.
 *
 * **Le cifre sono una proposta.** Come si fattura un acconto (netto o totale,
 * una fattura per incasso o una a saldo) e' una domanda ancora aperta con chi ne
 * risponde: il server calcola la quota proporzionale al versato, e la dice in
 * "Vedi i conti". Si cambia in un punto solo, sul server.
 *
 * **I ritocchi al testo non si salvano**: il testo e' dell'avviso, e cambiarlo
 * qui lo cambierebbe anche li'.
 */

import { incassi } from "../api";
import { useCarica } from "../carica";
import { dataCompleta, scadenzaFattura, type FatturaDelVersamento } from "../dominio";
import { PassiFattura, type DatiPassi } from "./PassiFattura";

function datiDi(f: FatturaDelVersamento): DatiPassi {
  const scad = scadenzaFattura(f.giorni_di_attesa, f.data);
  return {
    chi: f.intestatario,
    cosa: f.saldo ? "Fattura sul saldo" : "Fattura sull'acconto",
    contesto: `Incassati ${f.importo_versato} euro il ${dataCompleta(f.data)}, ${f.modalita.join(" e ")}${
      f.avviso_chiuso ? "" : `. All'avviso mancano ${f.residuo_avviso} euro`
    }.`,
    scadenza: scad,
    testo: f.testo,
    modificabile: false,
    importoRiga: f.importo_riga,
    totaleAtteso: f.totale_atteso,
    controllo: f.controllo,
    iva: f.iva,
    notaConti: f.nota_conti,
    avvertenze: f.da_guardare,
    numeroRegistrato: f.fattura_riferimento || undefined,
  };
}

export function FatturaAcconto({
  gruppo,
  posizione,
  numeriUsati,
  chiudi,
  registrato,
  apriAvviso,
}: {
  gruppo: string;
  posizione: { i: number; n: number } | null;
  numeriUsati: string[];
  chiudi: () => void;
  /** Dopo aver registrato il numero: ricarica le code e porta alla fattura successiva. */
  registrato: () => Promise<void>;
  apriAvviso: (documentoId: string) => void;
}) {
  const caricata = useCarica<FatturaDelVersamento>(() => incassi.fatturaDelGruppo(gruppo), [gruppo]);
  const f = caricata.dati;

  if (caricata.errore) {
    return (
      <article className="documento passi-fattura">
        <button type="button" className="tasto tasto-nudo torna" onClick={chiudi}>
          ‹ Torna all'elenco
        </button>
        <p className="errore" role="alert">
          {caricata.errore}
        </p>
      </article>
    );
  }
  if (f === undefined) {
    return (
      <article className="documento passi-fattura">
        <p className="attesa">Un momento.</p>
      </article>
    );
  }
  return (
    <PassiFattura
      dati={datiDi(f)}
      posizione={posizione}
      numeriUsati={numeriUsati}
      chiudi={chiudi}
      registra={async (numero) => {
        await incassi.segnaFatturato(gruppo, numero);
        await registrato();
      }}
      vediAvviso={() => apriAvviso(f.documento_id)}
    />
  );
}
